/**
 * Component to display and validate password field
 */
import { View } from "extensions/marionette";
import { PopoverView, PopoverModel } from "common/components/popover";
import { View as ValidatorView, Model as ValidatorModel } from "common/components/validator";

import { _ } from "extensions/underscore";
import $ from "jquery";

import strings from "common/strings";

import template from "./password.jst";

export const PasswordView = View.extend({
    template,
    ui: {
        input: ".password-input"
    },
    events: {
        "input @ui.input": function() {
            this.validator.model.set("value", this.ui.input.val());
        }
    },
    get() {
        return this.ui.input.val();
    },
    set(value) {
        this.ui.input.val(value);
        this.validator.model.set("value", value);
    },
    
    templateContext() {
        return {
            cid: this.cid
        };
    },
    /**
     * Show password in plain text instead ***
     */
    showPassword() {
        this.ui.input.attr("type", "text");
    },
    /**
     * Show password in *** instead of plain text
     */
    hidePassword() {
        this.ui.input.attr("type", "password");
    },
    
    instantiateValidator() {
        this.validator = new ValidatorView({
            model: new ValidatorModel(),
            token: this.getOption("token")
        });
        
        // Proxy validator events to the parent form
        this.listenTo(this.validator, "requirements", function(value) {
            this.trigger("requirements", value);
        });
    },
    
    computePopoverPlacement() {
        const windowWidth = $(window).width();
        let placement;
        
        if (windowWidth >= 992) { // 992 is md in bootstrap
            placement = "right";
        } else {
            placement = "bottom";
        }
        
        return placement;
    },
    
    instantiatePopover() {
        // Compute popover placement
        const placement = this.computePopoverPlacement();
        
        this.validatorPopover = new PopoverView({
            base: this.ui.input[0],
            render: true,
            model: new PopoverModel({
                placement,
                offsetTop: 0,
                title: strings.login.validator.title,
                dismissable: false,
                trigger: "manual"
            }),
            content: this.validator
        });
    },
    
    /**
     * Create validator and the popover
     */
    onAttach() {
        // https://support.apple.com/en-us/HT201303
        this.instantiateValidator();
        this.instantiatePopover();
    },
    
    /**
     * Focus inside the field
     */
    focus() {
        this.ui.input.focus();
    },
    
    onDestroy() {
        _.each([this.validator, this.validatorPopover], (subview) => {
            if (subview) {
                subview.destroy();
            }
        });
    }
});
